module.exports = __webpack_public_path__ + "static/desktop/img/case4.5af8f129.png";